import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import {AccessRights} from "lib/constants/accessRights";
import SurveyListingComponent from "./surveyListing.page";
import LoadingComponent from "components/loading";
import {canAccess} from "../../../profile/redux/selector/profile.selector";

export default function SurveyListingContainer() {
  const history = useHistory()
  const hasSurveyViewAccessRight = useSelector(state =>
    canAccess(state, AccessRights.Survey.LISTING_READ));
  const hasSurveyAddAccessRight = useSelector(state =>
    canAccess(state, AccessRights.Survey.LISTING_WRITE_CREATE));
  const lang = useSelector(state => state.constant.languages);

  useEffect(() => {
    if (!hasSurveyViewAccessRight) {
      history.push("/admin/dashboard");
    }
  }, [history, hasSurveyViewAccessRight]);

  if (!hasSurveyViewAccessRight) return <LoadingComponent />;

  return (
    <SurveyListingComponent
      hasSurveyAddAccessRight={hasSurveyAddAccessRight}
      lang={lang}
    />
  );
}
